import type { ReactNode } from 'react'

/** One line of filters, chips or section facts above a table. */
export function FilterBar({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={`flex min-h-10 shrink-0 flex-wrap items-center gap-x-3 gap-y-1 border-b border-line px-4 py-1.5 text-[12px] text-text-2 ${className}`}
    >
      {children}
    </div>
  )
}

/** Neutral chip for FilterBar: a value, a tag or a toggle. */
export function Chip({ children, title }: { children: ReactNode; title?: string }) {
  return (
    <span
      title={title}
      className="inline-flex max-w-full items-center gap-1 truncate rounded-full bg-surface-active px-2.5 py-0.5 text-[11.5px] text-text-2"
    >
      {children}
    </span>
  )
}
